import { FieldPolicy } from '@apollo/client';
import { Category } from '../models/graphql';

export const workspaceCategoriesPolicy = (): FieldPolicy => {
  return {
    keyArgs: ['statusFilter'],
    read(existing: Category[], { readField }) {
      if (typeof existing === 'undefined') {
        return undefined;
      }

      return Array.from(existing).sort((a, b) =>
        ((readField('name', a) || '') as string).localeCompare((readField('name', b) || '') as string)
      );
    }
  };
};
